(function($) {
    "use strict";

    window.CONSTUTIL = window.CONSTUTIL || {};

    CONSTUTIL.utilities = {
        constructiveEqualHeight: function() {
            var equalHeightParents = $('.constructive-equal-height-parent');

            $.each(equalHeightParents, function(index) {
                var equalHeightParent = $(this),
                    equalHeightChildren = equalHeightParent.find('.constructive-equal-height-child'),
                    maxHeight = 0;
                $.each(equalHeightChildren, function(index) {
                    var child = $(this),
                        ruler = child.find('div.ruler');
                    if ( ruler.length === 0 ) {
                        ruler = child.wrapInner( "<div class='ruler'></div>");
                    }
                    var childHeight = ruler.outerHeight(true);
                    if (childHeight >= maxHeight) {
                        maxHeight = childHeight;
                    }
                });
                equalHeightChildren.css({
                    'height': maxHeight + 'px',
                });
            });
        }
    };

})(jQuery);
